window.quizzes = {

  "know-your-skin": {

    title: "Know Your Skin",

    questions: [

      {
    question: "How does your skin usually feel about 30 minutes after cleansing?",
    answers: [

        {
            text: "Tight and uncomfortable",
            score: { dry: 4 },
            insight: "Your skin often feels tight after cleansing, suggesting reduced natural oil production."
        },

        {
            text: "Comfortable and balanced",
            score: { normal: 4 },
            insight: "Your skin remains comfortable after cleansing, indicating a balanced skin barrier."
        },

        {
            text: "Dry cheeks but oily forehead",
            score: { combination: 4 },
            insight: "Different areas of your face behave differently, a classic sign of combination skin."
        },

        {
            text: "Oily almost everywhere",
            score: { oily: 4 },
            insight: "Your skin produces noticeable oil shortly after cleansing."
        }

    ]
},

      {
    question: "How shiny does your skin become during the day?",
    answers: [

        {
            text: "Almost never",
            score: { dry: 3 },
            insight: "Your skin rarely becomes shiny, which often indicates lower oil production."
        },

        {
            text: "Only occasionally",
            score: { normal: 3 },
            insight: "Your skin stays balanced throughout most of the day."
        },

        {
            text: "Mainly on my T-zone",
            score: { combination: 4 },
            insight: "Oil is mostly produced in your T-zone while other areas stay balanced."
        },

        {
            text: "Very shiny all over",
            score: { oily: 4 },
            insight: "Your skin consistently produces excess oil across your face."
        }

    ]
},

      {
    question: "How visible are your pores?",
    answers: [

        {
            text: "Very small",
            score: { dry: 2 },
            insight: "Smaller pores are commonly associated with drier skin."
        },

        {
            text: "Average",
            score: { normal: 3 },
            insight: "Your pore size suggests a balanced level of oil production."
        },

        {
            text: "Large on my nose and forehead",
            score: { combination: 4 },
            insight: "Larger pores in your T-zone are typical for combination skin."
        },

        {
            text: "Large across most of my face",
            score: { oily: 4 },
            insight: "Enlarged pores across your face often accompany higher sebum production."
        }

    ]
},

      {
    question: "How often does your skin feel tight?",
    answers: [

        {
            text: "Almost every day",
            score: { dry: 4 },
            insight: "Frequent tightness usually points toward a weakened moisture barrier."
        },

        {
            text: "Rarely",
            score: { normal: 3 },
            insight: "Your skin generally maintains its natural comfort."
        },

        {
            text: "Mostly on my cheeks",
            score: { combination: 3 },
            insight: "Dryness on your cheeks alongside other balanced areas suggests combination skin."
        },

        {
            text: "Never",
            score: { oily: 2 },
            insight: "Your skin naturally retains moisture throughout the day."
        }

    ]
},

      {
    question: "How often do you experience breakouts?",
    answers: [

        {
            text: "Almost never",
            score: { dry: 2 },
            insight: "Your skin experiences very little congestion."
        },

        {
            text: "Occasionally",
            score: { normal: 3 },
            insight: "Occasional blemishes are normal for balanced skin."
        },

        {
            text: "Mostly around my T-zone",
            score: { combination: 4 },
            insight: "Breakouts concentrated in your T-zone are common for combination skin."
        },

        {
            text: "Frequently",
            score: { oily: 5 },
            insight: "Frequent breakouts often accompany higher oil production."
        }

    ]
},

      {
    question: "How does your skin react during winter?",
    answers: [

        {
            text: "Becomes very dry",
            score: { dry: 5 },
            insight: "Cold weather noticeably reduces your skin's moisture levels."
        },

        {
            text: "Barely changes",
            score: { normal: 3 },
            insight: "Your skin remains relatively stable throughout seasonal changes."
        },

        {
            text: "Dry cheeks, oily forehead",
            score: { combination: 4 },
            insight: "Seasonal dryness mainly affects certain areas of your face."
        },

        {
            text: "Still feels oily",
            score: { oily: 3 },
            insight: "Your skin continues producing significant oil, even during colder months."
        }

    ]
},

      {
    question: "How often do you use moisturizer?",
    answers: [

        {
            text: "Twice every day",
            score: { dry: 4 },
            insight: "Regular moisturizing is often essential for dry skin."
        },

        {
            text: "Once daily",
            score: { normal: 3 },
            insight: "A consistent moisturizer is usually enough for balanced skin."
        },

        {
            text: "Only on certain areas",
            score: { combination: 4 },
            insight: "Targeting specific areas is common with combination skin."
        },

        {
            text: "Rarely",
            score: { oily: 2 },
            insight: "Many people with oily skin avoid moisturizer, although hydration is still important."
        }

    ]
},

      {
    question: "How sensitive is your skin to new products?",
    answers: [

        {
            text: "Very sensitive",
            score: { dry: 3 },
            insight: "Dry skin often has a more fragile skin barrier."
        },

        {
            text: "Sometimes",
            score: { normal: 3 },
            insight: "Some sensitivity is perfectly normal."
        },

        {
            text: "Depends on the area",
            score: { combination: 3 },
            insight: "Different parts of your face may react differently."
        },

        {
            text: "Hardly ever",
            score: { oily: 3 },
            insight: "Your skin appears fairly resilient."
        }

    ]
},

      {
    question: "By the afternoon, your skin usually feels...",
    answers: [

        {
            text: "Dry",
            score: { dry: 4 },
            insight: "Your skin likely struggles to retain moisture throughout the day."
        },

        {
            text: "Comfortable",
            score: { normal: 4 },
            insight: "Your skin maintains a healthy balance throughout the day."
        },

        {
            text: "Oily forehead, comfortable cheeks",
            score: { combination: 5 },
            insight: "This balance between oily and normal areas is characteristic of combination skin."
        },

        {
            text: "Oily all over",
            score: { oily: 5 },
            insight: "Oil production remains consistently high during the day."
        }

    ]
},

      {
    question: "Which statement describes your skin best?",
    answers: [

        {
            text: "It constantly needs hydration",
            score: { dry: 6 },
            insight: "Your answers consistently point toward dry skin that benefits from ongoing hydration."
        },

        {
            text: "It's balanced most of the time",
            score: { normal: 6 },
            insight: "Your skin appears naturally well-balanced with few concerns."
        },

        {
            text: "Different areas behave differently",
            score: { combination: 6 },
            insight: "Your skin has multiple needs depending on the area of your face."
        },

        {
            text: "It naturally produces lots of oil",
            score: { oily: 6 },
            insight: "Your answers strongly indicate naturally oil-rich skin."
        }

    ]
},

    ]

  },

 "should-you-use-a-face-oil": {

    title: "Should You Use a Face Oil?",

    questions: [

        {
            question: "Do you currently use a moisturizer every day?",
            answers: [
                { text: "Yes, morning and evening", score: { doesNotNeedOil: 3 } },
                { text: "Usually once a day", score: { maybeOil: 2 } },
                { text: "Only sometimes", score: { needsOil: 2 } },
                { text: "Rarely or never", score: { needsOil: 4 } }
            ]
        },

        {
            question: "How often does your skin feel dry or dehydrated?",
            answers: [
                { text: "Almost every day", score: { needsOil: 4 } },
                { text: "A few times a week", score: { needsOil: 3 } },
                { text: "Occasionally", score: { maybeOil: 2 } },
                { text: "Almost never", score: { doesNotNeedOil: 3 } }
            ]
        },

        {
            question: "After applying moisturizer, your skin usually feels...",
            answers: [
                { text: "Still dry", score: { needsOil: 4 } },
                { text: "Comfortable for a few hours", score: { maybeOil: 3 } },
                { text: "Comfortable all day", score: { doesNotNeedOil: 4 } },
                { text: "Sometimes greasy", score: { doesNotNeedOil: 2 } }
            ]
        },

        {
            question: "What is your biggest skincare concern?",
            answers: [
                { text: "Dryness", score: { needsOil: 4 } },
                { text: "Fine lines", score: { maybeOil: 3 } },
                { text: "Maintaining healthy skin", score: { maybeOil: 2 } },
                { text: "Excess oil", score: { doesNotNeedOil: 4 } }
            ]
        },

        {
            question: "Does your skin often look dull?",
            answers: [
                { text: "Yes", score: { needsOil: 3 } },
                { text: "Sometimes", score: { maybeOil: 2 } },
                { text: "Rarely", score: { doesNotNeedOil: 2 } },
                { text: "Never", score: { doesNotNeedOil: 3 } }
            ]
        },

        {
            question: "How often does your skin feel tight after cleansing?",
            answers: [
                { text: "Every time", score: { needsOil: 4 } },
                { text: "Often", score: { needsOil: 3 } },
                { text: "Occasionally", score: { maybeOil: 2 } },
                { text: "Never", score: { doesNotNeedOil: 3 } }
            ]
        },

        {
            question: "What best describes your climate?",
            answers: [
                { text: "Mostly cold or dry", score: { needsOil: 3 } },
                { text: "Changes throughout the year", score: { maybeOil: 2 } },
                { text: "Mostly warm", score: { doesNotNeedOil: 2 } },
                { text: "Mostly humid", score: { doesNotNeedOil: 3 } }
            ]
        },

        {
            question: "How much water do you usually drink each day?",
            answers: [
                { text: "Less than 1 liter", score: { needsOil: 3 } },
                { text: "1–2 liters", score: { maybeOil: 2 } },
                { text: "2–3 liters", score: { doesNotNeedOil: 2 } },
                { text: "More than 3 liters", score: { doesNotNeedOil: 3 } }
            ]
        },

        {
            question: "How many hours do you usually sleep?",
            answers: [
                { text: "Less than 6", score: { needsOil: 3 } },
                { text: "6–7", score: { maybeOil: 2 } },
                { text: "7–8", score: { doesNotNeedOil: 2 } },
                { text: "More than 8", score: { doesNotNeedOil: 3 } }
            ]
        },

        {
            question: "What do you want most from skincare?",
            answers: [
                { text: "Hydration", score: { needsOil: 4 } },
                { text: "Healthier-looking skin", score: { maybeOil: 3 } },
                { text: "Maintain what I have", score: { doesNotNeedOil: 3 } },
                { text: "Reduce shine", score: { doesNotNeedOil: 4 } }
            ]
        },

        {
            question: "Would you describe your routine as...",
            answers: [
                { text: "Very basic", score: { needsOil: 3 } },
                { text: "Fairly consistent", score: { maybeOil: 2 } },
                { text: "Well established", score: { doesNotNeedOil: 3 } },
                { text: "Minimal by choice", score: { maybeOil: 2 } }
            ]
        },

        {
            question: "Are you looking to prevent future skin concerns?",
            answers: [
                { text: "Yes, definitely", score: { maybeOil: 3 } },
                { text: "Somewhat", score: { maybeOil: 2 } },
                { text: "Not really", score: { doesNotNeedOil: 2 } },
                { text: "I'm not sure", score: { needsOil: 2 } }
            ]
        }

    ]

},

};